module.exports = __webpack_public_path__ + "factorContributionsToReturnTrend.38386191b718dfe065769b0f6faabb72.png";